import { fabric } from "fabric";

export const getPolyVertices = (poly: fabric.Polygon) => {
  const points = poly.points,
    vertices: fabric.Point[] = [];

  points?.forEach((point) => {
    // Ajuste les coordonées des points par rapport à la position du polygone
    const x = point.x - poly.pathOffset.x,
      y = point.y - poly.pathOffset.y;

    vertices.push(
      // Applique la transformation du polygone sur les points
      fabric.util.transformPoint(
        { x: x, y: y } as fabric.Point,
        fabric.util.multiplyTransformMatrices(
          // canvas.viewportTransform || [],
          [1, 0, 0, 1, 0, 0],
          poly.calcTransformMatrix()
        )
      )
    );
  });

  return vertices;
};

export const updatePointsPosition = (polygon: fabric.Polygon) => {
  const newVertices = getPolyVertices(polygon);

  const newPoints: fabric.Point[] = [];
  newVertices.forEach((vertice: fabric.Point) => {
    newPoints.push({ x: vertice.x, y: vertice.y } as fabric.Point);
  });

  return newPoints;
};
